import React, { useEffect } from "react";
import { PaymentApi } from "api";
import { PaziaModal } from "components/molecules";
import { GenerateCustomInvoiceForm } from "./GenerateCustomInvoiceForm";
import { useInvoiceConfiguration } from "api/payments/useInvoiceConfiguration";

interface GenerateCustomInvoiceModalProps {
  onCloseRequest: (generated?: boolean) => void;
  payment: PaymentApi | null;
  courseId?: number;
}

export const GenerateCustomInvoiceModal = ({ onCloseRequest, payment, courseId }: GenerateCustomInvoiceModalProps) => {
  const { configuration, isLoading, invalidate } = useInvoiceConfiguration(payment?.id, courseId);

  // Clean up when modal closes
  useEffect(() => {
    if (!payment) {
      // Modal is closed, invalidate to ensure fresh data on next open
      invalidate();
    }
  }, [payment, invalidate]);

  const handleSuccess = () => {
    onCloseRequest(true);
    invalidate();
  };

  const handleCancel = () => {
    onCloseRequest();
    invalidate();
  };

  return (
    <PaziaModal
      id="generate-custom-invoice-modal"
      onCloseRequest={onCloseRequest}
      isOpen={payment != null}
      size="4xl"
      className="flex max-h-[90vh] flex-col overflow-hidden p-6"
    >
      <h2 className="mb-4 flex-shrink-0 text-xl font-semibold">Generuj fakturę niestandardową</h2>
      {isLoading ? (
        <div className="flex flex-1 items-center justify-center">
          <div className="text-center">
            <div className="mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-blue-600"></div>
            <p className="text-gray-600">Ładowanie danych faktury...</p>
          </div>
        </div>
      ) : (
        <>
          {configuration && payment && (
            <GenerateCustomInvoiceForm
              key={`form-${configuration.number}-${payment.id}-${payment != null ? "open" : "closed"}`}
              paymentId={payment.id}
              courseId={courseId}
              configuration={configuration}
              onSuccess={handleSuccess}
              onCancel={handleCancel}
            />
          )}
        </>
      )}
    </PaziaModal>
  );
};
